import { NgModule, ApplicationRef } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { routing } from "./app.routing";
import { NgbModule, NgbTooltipConfig } from "@ng-bootstrap/ng-bootstrap";
import { NavbarComponent } from "./shared/navbar.component";
import { AuthenticationService } from "./shared/authentication.service";
import { HomeComponent } from "./home/home.component";
import { MenuComponent } from "./shared/menu.component";
import { MessageComponent } from "./messages/components/message.component";
import { AddMessageComponent } from "./messages/add.component";
import { EditMessageComponent } from "./messages/edit.component";
import { CheckMessageComponent } from "./messages/check.component";
import { ImportMessageComponent } from "./messages/import.component";
import { Api } from "./shared/api.service";
import { createNewHosts, removeNgStyles } from "@angularclass/hmr";
import { MessagesComponent } from "./messages/components/messages.component";
import { MomentModule } from "angular2-moment";
import { MessageOverviewComponent } from "./messages/overview.component";
import { RlTagInputModule } from "angular2-tag-input/dist";
import {
  LanguagesGroupedResolver,
  LanguagesResolver,
} from "./shared/languages.resolver";
import { UsersResolver } from "./shared/resolvers/users.resolver";
import { ConfirmationModalComponent } from "./shared/modals/confirmation.modal";
import { ModalService } from "./shared/modal.service";
import { SettingsModule } from "./settings/settings.module";
import { CompaniesResolver } from "./shared/resolvers/companies.resolver";
import { RolesResolver } from "./shared/resolvers/roles.resolver";
import { UnauthorizedModalComponent } from "./shared/modals/unauthorized.modal";
import { NgDragDropModule } from "ng-drag-drop";
import { Utils } from "./shared/utils.service";
import { PermissionsResolver } from "./shared/resolvers/permissions.resolver";
import { CanDo } from "./shared/CanDo";
import { MessageModal } from "./messages/components/message.modal";
import { MessagecentralsResolver } from "./shared/resolvers/messagecentrals.resolver";
import { StatisticsModule } from "./statistics/statistics.module";
import { InsightsModule } from "./insights/insights.module";
import {
  BaseResolver,
  BasesResolver,
  GroupedBasesResolver,
} from "./shared/resolvers/bases.resolver";
import { NgSelectModule } from "@ng-select/ng-select";
import { NouisliderModule } from "ng2-nouislider";
import { ButtonOptionsComponent } from "./shared/button-options.component";
import { LoadingComponent } from "./shared/loading.component";
import { KeysPipe } from "./shared/pipes/keys.pipe";
import { SchemasModule } from "./schemas/schemas.module";
import { SchemaResolver } from "./shared/resolvers/schemas.resolver";
import { ContactMomentsResolver } from "./shared/resolvers/contact-moments.resolver";
import { SharedModule } from "./shared/shared.module";
import { TenantService } from "./shared/tenant.service";
@NgModule({
  imports: [
    NgbModule.forRoot(),
    NgDragDropModule.forRoot(),
    BrowserModule,
    FormsModule,
    RlTagInputModule,
    ReactiveFormsModule,
    HttpModule,
    MomentModule,
    NgSelectModule,
    NouisliderModule,
    SharedModule,
    SettingsModule,
    StatisticsModule,
    InsightsModule,
    SchemasModule,
    routing,
  ],
  declarations: [
    AppComponent,
    NavbarComponent,
    MenuComponent,
    LoginComponent,
    HomeComponent,
    AddMessageComponent,
    ImportMessageComponent,
    CheckMessageComponent,
    EditMessageComponent,
    MessagesComponent,
    MessageComponent,
    MessageOverviewComponent,
    ConfirmationModalComponent,
    UnauthorizedModalComponent,
    MessageModal,
    ButtonOptionsComponent,
    LoadingComponent,
    KeysPipe,
  ],
  providers: [
    Api,
    Utils,
    AuthenticationService,
    ModalService,
    LanguagesResolver,
    LanguagesGroupedResolver,
    UsersResolver,
    CompaniesResolver,
    RolesResolver,
    PermissionsResolver,
    NgbTooltipConfig,
    CanDo,
    MessagecentralsResolver,
    BasesResolver,
    BaseResolver,
    GroupedBasesResolver,
    SchemaResolver,
    ContactMomentsResolver,
    Title,
    TenantService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmationModalComponent,
    UnauthorizedModalComponent,
    MessageModal,
  ],
})
export class AppModule {
  constructor(
    private tooltipConfig: NgbTooltipConfig,
    public appRef: ApplicationRef
  ) {
    // Set the global tooltip configuration.
    this.tooltipConfig.container = "body";
    this.tooltipConfig.placement = "right";
  }

  hmrOnInit(store) {
    console.log("HMR store", store);
  }

  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(
      (cmp) => cmp.location.nativeElement
    );

    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);

    // remove styles
    removeNgStyles();
  }

  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();

    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.module.ts